import { render, staticRenderFns } from "./DialogTimesheetEditorDay.vue?vue&type=template&id=2b2958d9&scoped=true&"
import script from "./DialogTimesheetEditorDay.vue?vue&type=script&lang=js&"
export * from "./DialogTimesheetEditorDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2958d9",
  null
  
)

export default component.exports